module.exports = __webpack_public_path__ + "static/media/oxen.90af7a34.png";